import React, { forwardRef } from "react";
import classNames, { Argument } from "classnames/dedupe";
import bemMod from "../../../helpers/bemMod";

export type TDrawerMaskMods = "header" | "drawer" | "hidden" | "active";

export interface IDrawerMaskProps {
  classes?: {
    root?: Argument;
  };
  mods?: TDrawerMaskMods[];
  [key: string]: unknown;
}

export const MASK_CLASSNAME = "drawer-mask";

const DrawerMask = forwardRef<HTMLDivElement, IDrawerMaskProps>(
  ({ classes, mods = [], ...rest }, ref) => {
    const cls = classNames(
      MASK_CLASSNAME,
      bemMod(MASK_CLASSNAME, mods),
      classes?.root,
    );
    return <div data-testid="DrawerMask" className={cls} ref={ref} {...rest} />;
  },
);

export default DrawerMask;
